import ActionRow from '@shared/components/core/row/ActionRow';
import { LightXSmall } from '@shared/components/core/text/Typography';
import { obscureString } from '@shared/hooks/helpers/ObscureText';
import useRelativeTime from '@shared/hooks/useRelativeTime';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

interface IProjectClientActionProps {
    clientId?: string;
    title: string;
    createdDate?: string;
}

export default function ClientAction({ clientId, title, createdDate }: IProjectClientActionProps) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const getRelativeTime = useRelativeTime();
    createdDate = createdDate || new Date().toISOString();

    const handleNavigate = () => {
        navigate(`client/${clientId}`);
    };

    if (!clientId || !title || !createdDate) return null;
    return (
        <ActionRow
            iconSize={24}
            title={title}
            description={t('common:profile.share.created', 'Created: ', {
                value: getRelativeTime(new Date(createdDate)),
            })}
            onClick={handleNavigate}>
            <LightXSmall as="span">
                {t('common:organization.projects.key.title') + ': ' + obscureString(clientId)}
            </LightXSmall>
        </ActionRow>
    );
}
